import React from "react";

interface HeaderHideIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const RPGHeaderHideIcon: React.FC<HeaderHideIconProps> = ({
  width = 13,
  height = 8,
  className,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 13 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10.2025 7.89923C10.2733 7.96494 10.3726 8 10.4624 8C10.6515 8 10.8262 7.84226 10.8262 7.66264C10.8262 7.57502 10.7885 7.4874 10.7175 7.42167L2.81171 0.0963774C2.74082 0.0306694 2.64631 0 2.55181 0C2.36277 0 2.18795 0.157716 2.18795 0.332952C2.18795 0.424961 2.22103 0.512578 2.2919 0.573917L10.2025 7.89923ZM10.6467 6.65937C12.1305 5.76997 13 4.61336 13 4.10076C13 3.21138 10.3774 0.376772 6.50237 0.376772C5.69904 0.376772 4.94766 0.503819 4.25773 0.714115L5.49111 1.85323C5.79825 1.73056 6.13851 1.66046 6.50237 1.66046C7.96731 1.66046 9.14392 2.73382 9.14392 4.10076C9.14392 4.43373 9.06834 4.75355 8.92181 5.03395L10.6467 6.65937ZM6.50237 7.82474C7.37659 7.82474 8.1894 7.68018 8.91716 7.44358L7.66487 6.28257C7.31988 6.44907 6.92294 6.54106 6.50237 6.54106C5.02801 6.54106 3.86077 5.43263 3.85606 4.10076C3.85606 3.70647 3.9553 3.33406 4.13486 3.00548L2.49038 1.47205C0.930939 2.36144 0 3.57501 0 4.10076C0 4.98576 2.66994 7.82474 6.50237 7.82474ZM8.0051 4.00875C8.0051 3.24205 7.3388 2.61993 6.50237 2.61993C6.44094 2.61993 6.37949 2.6243 6.32281 2.62869L7.99565 4.17962C8.00039 4.12706 8.0051 4.06572 8.0051 4.00875ZM4.99492 3.99999C4.99492 4.77107 5.68012 5.3932 6.5071 5.3932C6.57326 5.3932 6.63469 5.38883 6.70085 5.38444L5.00437 3.8116C4.99964 3.87294 4.99492 3.93865 4.99492 3.99999Z"
      fill="#0F0E10"
    />
  </svg>
);
